import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import machineServiceImageListAction from './machineServiceImageList.action.json' with { type: 'json' }
import { machineServiceImageObject } from '../machineServiceImageObject'

export const machineServiceImageExpression = expression(machineServiceImageObject.shape)

const machineServiceImageListDefinition = defineAction({
  ...machineServiceImageListAction,

  input: z.object({
    filter: machineServiceImageExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      machineServiceId: 'Serviço de máquina',
      description: 'Descrição',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(machineServiceImageObject),
    count: z.number(),
  }),
})

export default machineServiceImageListDefinition
